import styled from "styled-components";
import { Tabs as AntTabs } from "antd";
import { theme } from "../../../config";

export const TabsStyled = styled(AntTabs)`
  &.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab,
  .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab {
    border-radius: 8px 8px 0 0;
    font-size: 15px;
    font-weight: 700;
    line-height: 18px;
    padding-left: 27px;
    padding-right: 27px;
    height: 48px;
    @media ${theme.breakpoints.mobileAndTablet} {
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
    }
  }

  &.ant-tabs-card.ant-tabs-top
    > .ant-tabs-nav
    .ant-tabs-tab:not(:nth-last-child(2)),
  .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab {
    margin-right: 4px;
  }

  .ant-tabs-tab:hover,
  .ant-tabs-tab:active,
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${theme.colors.secondary};
  }
  .ant-tabs-tab-btn {
    font-family: "Orkney Bold";
    color: ${theme.colors.custom.darkblue3};
  }
  .ant-tabs-nav {
    margin-bottom: -1px;
    margin-left: -1px;
  }

  .ant-tabs-tab {
    font-family: 'Orkney Bold';
  }
`;
